import { createSlice } from '@reduxjs/toolkit';
import getLanguage from 'components/helpers/getLanguage';

const lang = getLanguage();

const languageSlice = createSlice({
  name: 'current-language',
  initialState: { lang },
  reducers: {
    updateLanguage: (state, { payload }) => {
      localStorage.setItem('lang', payload);
      return {
        ...state,
        lang: payload,
      };
    },
  },
});

export const { updateLanguage } = languageSlice.actions;

export default languageSlice.reducer;
